module.exports = __webpack_public_path__ + "img/draw.ea03a78e.png";